module.exports = __webpack_public_path__ + "img/logo.5da6ec6d.png";